import React, {useEffect, useState} from 'react';

import CanvasJSChart from "./CanvasJSChart";
import SpinnerDiv from "root/Components/SpinnerDiv";
import {getDataFromResponse, getNumRowsFromResponse} from "root/DataFunctions/BaseDataFns";
import {getChildAgeRangesForTeam} from "root/DataFunctions/DashboardDataFns";
import {dashboardDefaults, defaultTitleFontSize} from "root/dashboard/DashboardDefault";

const DashboardPanelTeamChildAge = ({title, team_id, height, panelStyle}) =>
{
	const [ data, setData ] = useState ({ loading: true, data: []}) ;

	useEffect(() =>
	{
		getServerData() ;
	}, []);

    const generateDataPoints = ( items ) =>
	{
		return items.map ((item) =>
			{
				return ({
					label: item.range,
					y: item.count,
					tool: item.count
				})
			}
		)
	}

	const getServerData = () => {

		getChildAgeRangesForTeam( team_id,  (response) =>
		{
			const recs = getDataFromResponse(response);

			setData ( { loading: false, data : recs}) ;
		});
	};

	const formPanel = () =>
	{
		const options = {
			maintainAspectRatio: false,
			responsive: true,
			animationEnabled: true,
			height: height,
			...dashboardDefaults,
			title: {
				text: title,
				fontSize: defaultTitleFontSize
			},
			data: [
				{
					type: 'column',
					lineColor: 'red',
					indexLabelPlacement: 'inside',    //Try Changing to outside
					showInLegend: true,
					legendMarkerColor: 'grey',
					legendText: 'Number of Children In Age Range',
					toolTipContent: '{tool}',
					dataPoints: generateDataPoints(data.data)
				}
			] } ;

		return (
			<div className={'panel ' + panelStyle}>
				<div className='panel-body'>
					<CanvasJSChart id='chartChildAge' options={options} uniqueId='chartChildAge' />
				</div>
			</div>
		)
	}

	return data.loading === true ? <SpinnerDiv/> : formPanel() ;
}

export default DashboardPanelTeamChildAge;

DashboardPanelTeamChildAge.defaultProps =
{
	title: 'title',
	height: 500,
	panelStyle: 'panel-default',
}